import { render, staticRenderFns } from "./SampleVestimateReportLayout.vue?vue&type=template&id=6ebb0fa5"
import script from "./SampleVestimateReportLayout.vue?vue&type=script&lang=js"
export * from "./SampleVestimateReportLayout.vue?vue&type=script&lang=js"
import style0 from "./SampleVestimateReportLayout.vue?vue&type=style&index=0&id=6ebb0fa5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports